import React from "react";
import TicketDetailItemPrivate from "./TicketDetailItemPrivate";
import TicketDetailItemPublic from "./TicketDetailItemPublic";
import type { CurrentTicketType } from "../../../modules/ticket/ticketDetail/currentTicket/currentTicketSlice";

const ticketIsPrivate = (item: CurrentTicketType): boolean => {
  const hasTypeAccess = !Boolean(
    item && item.accessibleByTypes && item.accessibleByTypes.length,
  );
  return hasTypeAccess;
};

interface TicketDetailItemProps {
  item: CurrentTicketType;
}

const TicketDetailItem: React.FC<TicketDetailItemProps> = ({ item }) => {
  const isPrivate = ticketIsPrivate(item);

  return isPrivate ? (
    <TicketDetailItemPrivate item={item} />
  ) : (
    <TicketDetailItemPublic item={item} />
  );
};

export default TicketDetailItem;
